import {JsonProperty} from '@hyperloris/tyson';

export class RecoverPassword {
  @JsonProperty()
  newPassword: string | undefined;
  @JsonProperty()
  confirmPassword: string | undefined;
}
